import type { GameState, LockSeatOrderAction } from "../types";

export function applyLockSeatOrder(
  state: GameState,
  _action: LockSeatOrderAction,
): GameState {
  return {
    ...state,
    version: state.version + 1,
    seatLocked: true,
  };
}
